import { SVGToBase64 } from 'core/service/lib/tobase64'
import MESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'

// FIXME: write test
export const generateProductGraph = async (basicPlanCode) => {
  const isWebBrowser = !window.cordova
  try {
    const rawGraphSVG = await import(
      /* webpackChunkName: "b64image" */ `!svg-inline-loader!assets/images/product-benefits/Graph-${basicPlanCode}.svg`
    ).then((m) => m.default)
    return await SVGToBase64(rawGraphSVG, isWebBrowser, basicPlanCode)
  } catch (e) {
    return ''
  }
}

// FIXME: evaluate if BIProps type can be used (medium/large)
// FIXME: write test
export const createCommonPdf = async (props, createFullBIPdf, createMiniBIPdf) => {
  // $$FlowFixMe
  const getDefault = (m) => m.default

  props.redLine = await import(/* webpackChunkName: "b64image" */ '!url-loader!assets/images/ktaxa-red-line.png').then(
    getDefault
  )
  // $$FlowFixMe
  props.logo = await import(/* webpackChunkName: "b64image" */ '!url-loader!assets/images/logo-ktaxa-th.png').then(
    getDefault
  )

  props.productGraph =
    Object.values(VALUES.GLOBAL_INDEX_16_6_CODE).includes(props.basicPlan.code) ||
    Object.values(VALUES.INDEX_LINKED_25_5_CODE).includes(props.basicPlan.code) ||
    Object.values(VALUES.INDEX_LINKED_15_8_CODE).includes(props.basicPlan.code)
      ? await import(
          /* webpackChunkName: "b64image" */ `!url-loader!assets/images/product-benefits/Graph-${props.basicPlan.code}.png`
        ).then(getDefault)
      : VALUES.IHEALTHY_ULTRA_IHEALTHY_CODE.includes(props.basicPlan.code)
      ? await generateProductGraph(props.basicPlan.code)
      : await generateProductGraph(props.basicPlan.basicPlanCode)

  return props.biType === MESSAGES.BI_TYPE_FULL ? await createFullBIPdf(props) : await createMiniBIPdf(props)
}
